/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'geo fencing': {
    width: 16,
    height: 16,
    viewBox: '0 0 108.88 62',
    data: '<defs/><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path pid="0" class="cls-1" d="M74.25 20.29a19.79 19.79 0 0 0-39.58 0c0 7 3.81 14.27 10.21 21.29A71.33 71.33 0 0 0 52 48.37c.42.35 2.45 2 2.45 2s2-1.6 2.45-2a71.33 71.33 0 0 0 7.1-6.79"/><path pid="1" class="cls-1" d="M54.46 32.16a11.87 11.87 0 1 1 11.88-11.87 11.87 11.87 0 0 1-11.88 11.87z"/><path pid="2" class="cls-1" d="M52 48.37a71.33 71.33 0 0 1-7.12-6.79c-6.4-7-10.21-14.28-10.21-21.29a19.79 19.79 0 0 1 39.58 0 24.26 24.26 0 0 1-2.79 10.8M64 41.58a71.33 71.33 0 0 1-7.12 6.79"/><path pid="3" class="cls-2" d="M74.5 33.33h5.68l28.2 28.17H.5l28.19-28.17h5.67"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/icons/geo fencing.js